import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function VenueExecCapsuleChartHelp() {
    return (
        <IconTooltip>
            <div>
                The first bar in the capsule displays the historical execution
                venues that this symbol typically trades in on a market wide
                level. The second bar displays today&apos;s breakdown of
                execution venues that this symbol is trading in on a market wide
                level. The third and final bar displays your order&apos;s
                breakdown of execution venues that your symbol has traded in.
                Click on each bar to flip the capsule and see a detailed
                breakdown of execution venue analysis. In the case your order is
                still open/has no fills, the order bar will not be displayed.
            </div>
        </IconTooltip>
    );
}
